import { chat } from '@/api'

import {
	CHAT_DELETE_MESSAGE,
	CHAT_DELETE_MESSAGE_ERROR,
	CHAT_DELETE_MESSAGE_STATUS,
	CHAT_DELETE_RECIPIENT_MESSAGE,
	CHAT_EDIT_MESSAGE,
	CHAT_EDIT_MESSAGE_ERROR,
	CHAT_EDIT_MESSAGE_STATUS,
	CHAT_EDIT_RECIPIENT_MESSAGE,
	CHAT_FETCH,
	CHAT_FETCH_ERROR,
	CHAT_FETCH_STATUS,
	CHAT_STORE_MESSAGE,
	CHAT_STORE_MESSAGE_ERROR,
	CHAT_STORE_MESSAGE_STATUS,
	CHAT_STORE_RECIPIENT_MESSAGE,
	CHAT_MESSAGES_FETCH,
	CHAT_MESSAGES_FETCH_ERROR,
	CHAT_MESSAGES_FETCH_STATUS,
	CHAT_GET_STATUS,
	CHAT_GET,
	CHAT_GET_ERROR,
	CHAT_START_ERROR,
	CHAT_START,
	CHAT_DELETE,
	CHAT_DELETE_STATUS,
	CHAT_DELETE_ERROR,
	CHAT_VIOLATIONS_GET,
	CHAT_VIOLATIONS_GET_ERROR,
	CHAT_REPORT_STATUS,
	CHAT_REPORT_ERROR,
	CHAT_MESSAGE_READ,
	CHAT_MESSAGES_FETCH_MORE_STATUS,
} from './types'

const fetchMessages = async (ctx, params) => {
	ctx.commit(CHAT_MESSAGES_FETCH_STATUS, true)
	try {
		const { data } = await chat.fetchMessages(params)
		ctx.commit(CHAT_MESSAGES_FETCH, data)
		ctx.commit(CHAT_MESSAGES_FETCH_STATUS, false)
	} catch (e) {
		ctx.commit(CHAT_MESSAGES_FETCH_ERROR, e)
		console.error(e)
	}
}

const getMoreMessages = async (ctx, params) => {
	ctx.commit(CHAT_MESSAGES_FETCH_MORE_STATUS, true)
	try {
		const { data } = await chat.fetchMessages(params)
		ctx.commit(CHAT_MESSAGES_FETCH, data)
		ctx.commit(CHAT_MESSAGES_FETCH_MORE_STATUS, false)
	} catch (e) {
		ctx.commit(CHAT_MESSAGES_FETCH_ERROR, e)
		console.error(e)
	}
}

const fetchChats = async (ctx, query) => {
	ctx.commit(CHAT_FETCH_STATUS, true)
	try {
		const { data } = await chat.fetchChats(query)
		ctx.commit(CHAT_FETCH, data)
		ctx.commit(CHAT_FETCH_STATUS, false)
	} catch (e) {
		ctx.commit(CHAT_FETCH_ERROR, e)
		console.error(e)
	}
}

const getChat = async (ctx, id) => {
	ctx.commit(CHAT_GET_STATUS, true)
	try {
		const { data } = await chat.getChat(id)
		ctx.commit(CHAT_GET, data.data)
		ctx.commit(CHAT_GET_STATUS, false)
	} catch (e) {
		ctx.commit(CHAT_GET_ERROR, e)
		console.error(e)
	}
}

const startChat = async (ctx, id) => {
	try {
		const { data } = await chat.startChat(id)
		ctx.commit(CHAT_START, data.data)
	} catch (e) {
		ctx.commit(CHAT_START_ERROR, e)
		console.error(e)
	}
}

const storeMessage = async (ctx, { id, formData }) => {
	ctx.commit(CHAT_STORE_MESSAGE_STATUS, true)
	try {
		const { data } = await chat.storeMessage(id, formData)

		ctx.commit(CHAT_STORE_MESSAGE, data.data)
		ctx.commit(CHAT_STORE_MESSAGE_STATUS, false)
	} catch (e) {
		ctx.commit(CHAT_STORE_MESSAGE_ERROR, e)
		throw e
	}
}

const editMessage = async (ctx, data) => {
	ctx.commit(CHAT_EDIT_MESSAGE_STATUS, true)
	try {
		const response = await chat.editMessage(data.chatId, data)

		ctx.commit(CHAT_EDIT_MESSAGE, response)
		ctx.commit(CHAT_EDIT_MESSAGE_STATUS, false)
	} catch (e) {
		ctx.commit(CHAT_EDIT_MESSAGE_ERROR, e)
		console.error(e)
	}
}

const deleteMessage = async (ctx, chatData) => {
	ctx.commit(CHAT_DELETE_MESSAGE_STATUS, true)
	try {
		await chat.deleteMessage(chatData)
		ctx.commit(CHAT_DELETE_MESSAGE, chatData.messageId)
		ctx.commit(CHAT_DELETE_MESSAGE_STATUS, false)
	} catch (e) {
		ctx.commit(CHAT_DELETE_MESSAGE_ERROR, e)
		console.error(e)
	}
}

const deleteChat = async (ctx, chatId) => {
	ctx.commit(CHAT_DELETE_STATUS, true)
	try {
		const response = await chat.deleteChat(chatId)
		ctx.commit(CHAT_DELETE, response)
		ctx.commit(CHAT_DELETE_STATUS, false)
	} catch (e) {
		ctx.commit(CHAT_DELETE_ERROR, e)
		console.error(e)
	}
}

const sendReport = async (ctx, { chatId, userId, reason }) => {
	ctx.commit(CHAT_REPORT_STATUS, true)
	try {
		await chat.chatReport(chatId, userId, reason)
		ctx.commit(CHAT_REPORT_STATUS, false)
	} catch (e) {
		ctx.commit(CHAT_REPORT_ERROR, e)
		throw e
	}
}

const setMessageAsRead = async (ctx, messageId) => {
	ctx.commit(CHAT_MESSAGE_READ, messageId)
}

const getChatViolationsList = async (ctx) => {
	try {
		const { data } = await chat.getViolationsList()
		ctx.commit(CHAT_VIOLATIONS_GET, data.data)
	} catch (e) {
		ctx.commit(CHAT_VIOLATIONS_GET_ERROR, e)
		console.error(e)
	}
}

const storeRecipientMessage = async (ctx, message) => {
	ctx.commit(CHAT_STORE_RECIPIENT_MESSAGE, message)
}

const editRecipientMessage = async (ctx, message) => {
	ctx.commit(CHAT_EDIT_RECIPIENT_MESSAGE, message)
}

const deleteRecipientMessage = async (ctx, message) => {
	ctx.commit(CHAT_DELETE_RECIPIENT_MESSAGE, message)
}

export default {
	startChat,
	getChat,
	fetchMessages,
	fetchChats,
	storeMessage,
	editMessage,
	deleteMessage,
	storeRecipientMessage,
	editRecipientMessage,
	deleteRecipientMessage,
	deleteChat,
	getChatViolationsList,
	sendReport,
	setMessageAsRead,
	getMoreMessages,
}
